import { Reveal } from "./Reveal";
import { SectionHeading } from "./SectionHeading";

const architecture = [
  {
    title: "DEPLOYMENT PLATFORM",
    text: "Autonomous, heavily armored VTOL chassis featuring omni-directional repulsor pads and self-healing carbon-nanotube plating.",
  },
  {
    title: "PAYLOAD BAY",
    text: "Climate-controlled, vacuum-sealed thermal lockers capable of supporting organic perishables and quantum-battery components simultaneously.",
  },
  {
    title: "NAVIGATION CORE",
    text: "Sub-quantum routing node that bypasses irradiated dead-zones and subterranean hazards in real time.",
  },
];

const defense = [
  {
    title: "STASIS-PULSE EMITTERS",
    text: "Shoulder turrets discharge localized tachyon-dampening fields, freezing ballistic projectiles or biological attackers in suspended animation for 180 seconds.",
  },
  {
    title: "PHOTONIC BLINDING GRIDS",
    text: "High-intensity ultraviolet strobe matrices induce immediate, temporary optical overload in hostile raiding parties without permanent tissue damage.",
  },
  {
    title: "REPULSION WAVE INDUCTION",
    text: "Kinetic shockwave generators emit a non-damaging concussive blast, displacing attackers and clearing delivery perimeters instantly.",
  },
  {
    title: "STICKY-FOAM ENTANGLEMENT PODS",
    text: "Rapid-hardening aerogel units encase hostile limbs or weapon systems on impact, anchoring threats to surrounding terrain.",
  },
];

const workflow = [
  {
    title: "ORDER TRANSMISSION",
    text: "The customer logs a secure holographic request through the decentralized orbital relay network.",
  },
  {
    title: "TRANSIT & EVASION",
    text: "The courier navigates hostile wasteland sectors using automated decoy signatures and active camo plating.",
  },
  {
    title: "AUTOMATED INTERCEPTION RESPONSE",
    text: "The defense array evaluates threat levels, deploys the correct non-lethal deterrent, and logs the incident to the local security ledger.",
  },
  {
    title: "SECURE HANDSHAKE",
    text: "The payload releases only after biometric and encrypted key verification by the rightful owner.",
  },
];

export function CourierSystems() {
  return (
    <div className="courier-systems" data-testid="courier-systems-section">
      <section className="courier-system-section">
        <SectionHeading
          eyebrow="AETHER-GRID LOGISTICS"
          title="Apex-Courier MK-VII system architecture."
          text="The delivery platform is engineered for hostile-sector transport, sensitive payloads, and real-time route survival."
        />
        <div className="system-card-grid">
          {architecture.map((item, index) => (
            <Reveal className="system-card" delay={index * 0.07} key={item.title}>
              <span>{String(index + 1).padStart(2, "0")}</span>
              <h3>{item.title}</h3>
              <p>{item.text}</p>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="courier-system-section courier-defense-section" data-testid="nonlethal-defense-section">
        <SectionHeading
          eyebrow="NON-LETHAL DEFENSE ARRAY"
          title="Neutralize the ambush. Protect the cargo."
          text="Every countermeasure is designed to stop an attack without permanent injury."
        />
        <div className="defense-grid">
          {defense.map((item, index) => (
            <Reveal className="defense-card" delay={index * 0.06} key={item.title}>
              <div className="defense-icon" />
              <h3>{item.title}</h3>
              <p>{item.text}</p>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="courier-system-section" data-testid="operational-workflow-section">
        <SectionHeading
          eyebrow="OPERATIONAL WORKFLOW"
          title="From orbital request to verified delivery."
        />
        <div className="workflow-timeline">
          {workflow.map((item, index) => (
            <Reveal className="workflow-step" delay={index * 0.08} key={item.title}>
              <span>{String(index + 1).padStart(2, "0")}</span>
              <div>
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
